// extracted by mini-css-extract-plugin
export default {"filtersList":"UbboW0w4CCI0tsTOzjcA"};